export const personalInfo = {
    name: "Matin Kadri",
    role: "Website & Mobile App Developer",
    bio: "Passionate about creating intuitive and engaging user experiences. Specialize in transforming ideas into beautifully crafted products",
    email: "matinkadri07@gmail.com",
    location: "Mumbai, India",
  };
  
  export const skills = [
    "React Native",
    "React JS",
    "Next JS",
    "TypeScript",
    "JavaScript",
    "Firebase",
    "AWS",
    "HTML5 & CSS3",
    "Vercel",
    "Tailwind",
    "Bootstrap"
    
    // Add more skills as needed
  ];